import { enableProdMode } from '@angular/core';

import { bootstrapApplication } from '@angular/platform-browser';
import { registerLocaleData } from '@angular/common';
import af from '@angular/common/locales/af';
import localeZA from '@angular/common/locales/en-ZA';
import { environment } from './environments/environment';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';

if (environment.production) {
    enableProdMode();
}
if (localeZA != null && localeZA[13].toLocaleString().includes(',')) {
    //replace ',' with '.' in currency locale ZA
    localeZA[13] = localeZA[13].toLocaleString().replace(',', '.').split(',');
}

registerLocaleData(localeZA, 'en-ZA');
registerLocaleData(af, 'af');

document.addEventListener('DOMContentLoaded', () => {
    bootstrapApplication(AppComponent, appConfig).catch((err) => console.error(err));
});
